<style></style>
<template>
  <v-container fluid>
    <v-row class="text-center">
      <v-snackbar
        :color="alertMessageColor"
        :timeout="alertMessageTimeout"
        top
        v-model="alertMessageShow"
        vertical
      >
        <span v-html="alertMessageText"></span>
        <v-btn @click="alertMessageShow = false" color="pink" text>
          Fermer
        </v-btn>
      </v-snackbar>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="users"
          :search="userSearch"
          class="elevation-1"
          sort-by="id"
        >
          <template v-slot:top>
            <v-toolbar color="white" flat>
              <v-toolbar-title>Utilisateurs</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-text-field
                append-icon="search"
                clearable
                hide-details
                label="Rechercher parmi ces utilisateurs "
                single-line
                v-model="userSearch"
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-dialog max-width="961px" v-model="dialog">
                <template v-slot:activator="{ on }">
                  <v-btn @click="newItem" class="mb-2" color="primary" dark v-on="on">
                    New User
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="2">
                          <!--<v-text-field v-model="editedItem.name" label="Name"/>-->
                          <v-text-field
                            :error-messages="errorMessages"
                            :rules="[
                              () => !!editedItem.id || 'Ce champ est obligatoire',
                              () => editedItem.id > 0 || 'Nombre entier positif'
                            ]"
                            label="IdEmploye Goéland"
                            ref="id"
                            required
                            v-bind:clearable="!dialogFormObjetReadOnlyMode"
                            v-bind:disabled="dialogFormObjetReadOnlyMode"
                            v-bind:readonly="dialogFormObjetReadOnlyMode"
                            v-model="editedItem.id"
                          />
                        </v-col>
                        <v-col cols="12" sm="5">
                          <!--<v-text-field v-model="editedItem.name" label="Name"/>-->
                          <v-text-field
                            :counter="maxTextLength"
                            :error-messages="errorMessages"
                            :rules="[
                              () => !!editedItem.name || 'Ce champ est obligatoire',
                              () =>
                                editedItem.name.length <= maxTextLength || '255 caractères maximum'
                            ]"
                            label="Nom et Prénom"
                            ref="nom"
                            required
                            v-bind:clearable="!dialogFormObjetReadOnlyMode"
                            v-bind:disabled="dialogFormObjetReadOnlyMode"
                            v-bind:readonly="dialogFormObjetReadOnlyMode"
                            v-model="editedItem.name"
                          />
                        </v-col>
                        <v-col cols="12" sm="5">
                          <!--<v-text-field v-model="editedItem.email" label="Email"/>-->
                          <v-text-field
                            :counter="maxTextLength"
                            :error-messages="errorMessages"
                            :rules="[
                              () => !!editedItem.email || 'Ce champ est obligatoire',
                              () => /.+@.+\..+/.test(editedItem.email) || 'E-mail doit être valide',
                              () =>
                                editedItem.name.length <= maxTextLength || '255 caractères maximum'
                            ]"
                            label="Email"
                            ref="email"
                            required
                            v-bind:clearable="!dialogFormObjetReadOnlyMode"
                            v-bind:disabled="dialogFormObjetReadOnlyMode"
                            v-bind:readonly="dialogFormObjetReadOnlyMode"
                            v-model="editedItem.email"
                          />
                        </v-col>
                        <v-col cols="12" sm="6">
                          <!--<v-text-field v-model="editedItem.username" label="Username"/>-->
                          <v-text-field
                            :cleareable="true"
                            :rules="[() => !!editedItem.username || 'Ce champ est obligatoire']"
                            autocomplete="username"
                            id="username"
                            label="Username"
                            name="username"
                            prepend-icon="person"
                            ref="username"
                            required
                            type="text"
                            v-model="editedItem.username"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-text-field
                            :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                            :required="editedIndex < 0"
                            :type="showPassword ? 'text' : 'password'"
                            @click:append="showPassword = !showPassword"
                            id="password"
                            label="votre mot de passe"
                            name="password"
                            prepend-icon="lock"
                            ref="password"
                            v-model="password"
                          >
                          </v-text-field>
                          <v-text-field
                            id="password_hash"
                            label="sha256"
                            name="password_hash"
                            prepend-icon="lock"
                            ref="password_hash"
                            type="text"
                            v-model="password_hash"
                            v-show="sha256Visible"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-text-field label="Enterprise" v-model="editedItem.enterprise" />
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-text-field label="Téléphone" v-model="editedItem.phone" />
                        </v-col>
                        <v-col cols="12">
                          <!--<v-text-field v-model="editedItem.comment" label="comment"/>-->
                          <v-textarea
                            label="Commentaire"
                            prepend-icon="notes"
                            ref="commentaire"
                            rows="2"
                            v-bind:clearable="!dialogFormObjetReadOnlyMode"
                            v-bind:disabled="dialogFormObjetReadOnlyMode"
                            v-bind:readonly="dialogFormObjetReadOnlyMode"
                            v-model="editedItem.comment"
                          />
                        </v-col>
                        <v-col cols="12" md="4" sm="6">
                          <v-switch label="Is Admin?" v-model="editedItem.is_admin" />
                        </v-col>
                        <v-col cols="12" md="4" sm="6">
                          <v-switch label="Is Validator?" v-model="editedItem.is_validator" />
                        </v-col>
                        <v-col cols="12" md="4" sm="6">
                          <v-switch label="Is Manager?" v-model="editedItem.is_manager" />
                        </v-col>
                        <v-col cols="12" md="4" sm="6">
                          <v-switch
                            label="Is Locked?"
                            v-bind:disabled="!editedItem.is_locked"
                            v-bind:readonly="!editedItem.is_locked"
                            v-model="editedItem.is_locked"
                          />
                        </v-col>
                        <v-col cols="12" md="4" sm="6">
                          <v-switch label="Is Active?" v-model="editedItem.is_active" />
                        </v-col>
                        <v-col cols="12" md="4" sm="6">
                          <v-select
                            :items="secteursList"
                            item-text="nom"
                            item-value="id"
                            label="Secteur (laissez libre pour toute la Ville)"
                            v-model="editedItem.idsecteur"
                          />
                        </v-col>
                        <v-col cols="12" md="4" sm="6">
                          <v-select
                            :items="groupList"
                            item-text="nom"
                            item-value="id"
                            label="Groupe Utilisateur"
                            v-model="editedItem.id_group"
                          />
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="close" color="blue darken-1" text>Cancel</v-btn>
                    <v-btn @click="save" color="blue darken-1" text>Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <template v-slot:item.is_admin="{ item }">
            <v-btn small fab :color="item.is_admin ? 'blue' : 'orange'" dark>
              <v-icon>{{ item.is_admin ? "verified_user" : "clear" }}</v-icon>
            </v-btn>
          </template>
          <template v-slot:item.is_validator="{ item }">
            <v-btn small fab :color="item.is_validator ? 'blue' : 'orange'" dark>
              <v-btn icon>
                <v-icon>{{ item.is_validator ? "touch_app" : "clear" }}</v-icon>
              </v-btn>
            </v-btn>
          </template>
          <template v-slot:item.is_manager="{ item }">
            <v-btn small fab :color="item.is_manager ? 'blue' : 'orange'" dark>
              <v-btn icon>
                <v-icon>{{ item.is_manager ? "done" : "clear" }}</v-icon>
              </v-btn>
            </v-btn>
          </template>
          <template v-slot:item.is_locked="{ item }">
            <v-btn small fab :color="item.is_locked ? 'red' : 'green'" dark>
              <v-btn icon>
                <v-icon>{{ item.is_locked ? "lock" : "lock_open" }}</v-icon>
              </v-btn>
            </v-btn>
          </template>
          <template v-slot:item.is_active="{ item }">
            <v-btn small fab :color="item.is_active ? 'blue' : 'orange'" dark>
              <v-btn icon>
                <v-icon>{{ item.is_active ? "done" : "clear" }}</v-icon>
              </v-btn>
            </v-btn>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn small fab color="teal" dark title="Editer cet utilisateur">
              <v-icon @click="editItem(item)">{{ mdiPencil }}</v-icon>
            </v-btn>
            <v-btn small fab color="teal" dark class="ml-1" title="Effacer cet utilisateur">
              <v-icon @click="deleteItem(item)">{{ mdiDelete }}</v-icon>
            </v-btn>
          </template>
          <template v-slot:no-data>
            <v-btn @click="initialize" color="primary">Reset</v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mdiDelete, mdiPencil } from '@mdi/js';
import { isNullOrUndefined } from 'cgil-html-utils';
import { APP, DEV, getLog } from '../config';
import user from './User';
import group from './Group';
import { getPasswordHash, getUserId } from './Login';

const MODULE_NAME = 'UserManager';
const log = getLog(MODULE_NAME, 4, 2);

export default {
  name: 'UserManager',
  props: [],
  data: () => ({
    appName: APP,
    isInDev: DEV,
    alertMessageShow: false,
    alertMessageText: 'Rien à signaler',
    alertMessageTimeout: 7000, // 7 sec par defaut
    alertMessageColor: 'success',
    dialog: false,
    password: null,
    showPassword: false,
    sha256Visible: false,
    validLoginForm: false,
    userSearch: null,
    headers: [
      {
        text: 'Id',
        value: 'id',
      },
      {
        text: 'Name',
        align: 'start',
        // sortable: false,
        value: 'name',
      },
      {
        text: 'Email',
        value: 'email',
      },
      {
        text: 'Username',
        value: 'username',
      },
      {
        text: 'Groupe',
        value: 'groupe',
      },
      {
        text: 'Admin?',
        value: 'is_admin',
      },
      {
        text: 'Validator?',
        value: 'is_validator',
      },
      {
        text: 'Manager?',
        value: 'is_manager',
      },
      {
        text: 'Locked?',
        value: 'is_locked',
      },
      {
        text: 'Active?',
        value: 'is_active',
      },
      {
        text: 'Actions',
        value: 'actions',
        sortable: false,
      },
    ],
    users: [],
    groupList: [],
    secteursList: [
      { id: 0, nom: 'Toute la Ville' },
      { id: 1, nom: 'Hyper-centre' },
      { id: 2, nom: 'Est' },
      { id: 3, nom: 'Ouest' },
      { id: 4, nom: 'Nord' },
      { id: 5, nom: 'Sud' },
    ],
    isListUserRetrieved: false,
    maxTextLength: 255,
    editedIndex: -1,
    editedItem: {
      id: null,
      name: '',
      email: '',
      username: '',
      password_hash: '',
      enterprise: null,
      phone: null,
      comment: null,
      is_admin: false,
      is_validator: false,
      is_manager: false,
      is_locked: false,
      is_active: true,
      id_secteur: null,
      id_group: null,
    },
    defaultItem: {
      id: null,
      name: '',
      email: '',
      username: '',
      password_hash: '',
      enterprise: null,
      phone: null,
      comment: null,
      is_admin: false,
      is_validator: false,
      is_manager: false,
      is_locked: false,
      is_active: true,
      id_secteur: null,
      id_group: null,
    },
    dialogFormObjetReadOnlyMode: false,
    dialogFormObjetHasErrors: false,
    errorMessages: '',
    mdiDelete,
    mdiPencil,
  }),
  created() {
    this.initialize();
  },
  mounted() {
    log.t(`# ${MODULE_NAME} mounted()`);
  }, // end of mounted
  computed: {
    formTitle() {
      if (this.editedIndex === -1) {
        return 'Nouvel Utilisateur';
      }
      const item = this.users[this.editedIndex];
      return `Edition user id:${item.id}`;
    },
    password_hash() {
      return getPasswordHash(this.password);
    },
    formUser() {
      return {
        nom: this.editedItem.name,
        email: this.editedItem.email,
        username: this.editedItem.username,
      };
    },
  },

  watch: {
    dialog(val) {
      // val || this.close();
      if (val == null) {
        this.close();
      }
    },
  },

  methods: {
    showMessage(msgText, msgType = 'info') {
      this.alertMessageColor = msgType;
      this.alertMessageText = msgText;
      this.alertMessageShow = true;
    },
    initialize() {
      log.t('# IN initialize() before call user.getList()');
      group.getGroupList((data, errMessage) => {
        if (!isNullOrUndefined(data)) {
          this.groupList = data;
          log.l('# IN initialize -> groups data :', this.groupList);
        } else {
          log.e(`# GOT ERROR IN initialize() in callback for group.getGroupList data: ${errMessage}`);
        }
      });
      user.getList((data, errMessage) => {
        if (!isNullOrUndefined(data)) {
          this.users = data;
          log.l('# IN initialize -> objet data :', this.users);
          this.isListUserRetrieved = true;
        } else {
          log.e(`# GOT ERROR IN initialize() in callback for user.getList data: ${errMessage}`);
          this.isListUserRetrieved = false;
        }
      });
    },
    newItem() {
      log.t('# in newItem');
      this.editedIndex = -1;
      this.password = null;
      this.editedItem = { ...this.defaultItem };
      this.dialog = true;
    },
    editItem(item) {
      log.t('# in editItem');
      this.editedIndex = this.users.indexOf(item);
      this.editedItem = { ...item };
      user.getUser(item.id, (retval, errorMsg) => {
        if (errorMsg === 'SUCCESS') {
          log.w('# in editItem callback for user.getUser call val', retval);
          this.editedItem = { ...retval };
          this.dialog = true;
        } else {
          log.e(
            `# ERROR in editItem callback for user.getUser call
            ERROR : ${errorMsg}
            val`,
            retval,
          );
          this.showMessage(
            `ERREUR pendant la récupération de cet enregistrement !
              ${errorMsg}`,
            'error',
          );
        }
      });
    },

    deleteItem(item) {
      log.t('# in deleteItem');
      const index = this.users.indexOf(item);
      const rx = /\[(.+)\]/gm;
      const { id } = this.users[index];
      if (id === getUserId()) {
        this.showMessage('Vous ne pouvez pas effacer votre propre compte !', 'error');
        return;
      }
      // eslint-disable-next-line
      if (confirm(`Etes vous sur de vouloir effacer l\`enregistrement id:${id}? `)) {
        user.deleteUser(id, (retval, errorMsg) => {
          if (errorMsg === 'SUCCESS') {
            log.w('# in saveDialog callback for user.deleteUser call val', retval);
            const idDeleted = rx.exec(retval.message)[1];
            this.showMessage(`L\`enregistrement a été effacé de la BD id ${idDeleted}`, 'success');
            log.w(`# in saveDialog for existing item id ${retval}`);
            this.users.splice(index, 1);
            // that.close();
          } else {
            log.e(
              `# ERROR in saveDialog callback for user.deleteUser call
            ERROR : ${errorMsg}
            val`,
              retval,
            );
            this.showMessage(
              `ERREUR pendant l\`effacement de cet enregistrement !
              ${errorMsg}`,
              'error',
            );
          }
        });
      }
    },

    close() {
      log.t('# in close');
      this.dialog = false;
      this.password = null;
      setTimeout(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      log.t('# in save');
      this.dialogFormObjetHasErrors = false;
      Object.keys(this.formUser).forEach((f) => {
        log.w(`in saveDialog iterating fields ${f} - this.formObjet[f] ${this.formUser[f]}`);
        if (!this.$refs[f].validate(true)) {
          this.dialogFormObjetHasErrors = true;
        }
        this.$refs[f].validate(true);
      });
      if (!this.dialogFormObjetHasErrors) {
        if (this.editedIndex > -1) {
          // SAVING MODIFICATIONS TO EXISTING OBJECT
          log.w(`# in saveDialog, EDITING  for index : ${this.editedIndex}`);
          Object.assign(this.users[this.editedIndex], this.editedItem);
          const tempUser = { ...this.editedItem };
          if (!isNullOrUndefined(this.password) && this.password.trim().length > 2) {
            tempUser.password_hash = `${this.password_hash}`;
          } else {
            tempUser.password_hash = ''; // no modification to password
          }
          if (!isNullOrUndefined(tempUser.create_time)) delete tempUser.create_time;
          if (!isNullOrUndefined(tempUser.last_modification_time)) {
            delete tempUser.last_modification_time;
          }
          if (tempUser.idsecteur === 0) {
            tempUser.idsecteur = null;
          }
          user.modifyUser(tempUser, (retval, errorMsg) => {
            if (errorMsg === 'SUCCESS') {
              log.w('# in saveDialog callback for user.modifyUser call val', retval);
              // retval is the new index
              this.showMessage(
                `Les données ont été sauvée dans la Base id ${retval.id}`,
                'success',
              );
              this.initialize(); // on recupere la liste a jour
              log.w(`# in saveDialog for existing item id ${retval}`);
            } else {
              log.e(
                `# ERROR in saveDialog callback for user.modifyUser call
            ERROR : ${errorMsg}
            val`,
                retval,
              );
              this.showMessage(
                `ERREUR pendant la sauvegarde de cet objet !
              ${errorMsg}`,
                'error',
              );
            }
          });
        } else {
          // SAVING NEW OBJECT
          log.l(`# in saveDialog, will save new objet ${this.editedIndex}`);
          // const that = this;
          const tempUser = { ...this.editedItem };
          if (tempUser.idsecteur === 0) {
            tempUser.idsecteur = null;
          }
          tempUser.id = Number(tempUser.id);
          tempUser.password_hash = `${this.password_hash}`;
          user.newUser(tempUser, (retval, errorMsg) => {
            if (errorMsg === 'SUCCESS') {
              log.w('# in saveDialog callback for user.newUser call val', retval);
              // retval is the new index
              this.showMessage(
                `Les données de cet objet ont été sauvée dans la Base id ${retval.id}`,
                'success',
              );
              log.w(`# in saveDialog for new item id ${retval}`);
              this.editedItem.datecreated = new Date();
              // this.editedItem.id = retval.id;
              this.users.push(this.editedItem);
              this.initialize(); // on recupere la liste a jour
            } else {
              log.e(
                `# ERROR in saveDialog callback for objet.newObjet call
            ERROR : ${errorMsg}
            val`,
                retval,
              );
              this.showMessage(
                `ERREUR pendant la sauvegarde de cet objet !
              ${errorMsg}`,
                'error',
              );
            }
          });
        }
        this.close();
      } else {
        log.e('# ERRORS in saveDialog');
      }
    },
  }, // end of methods
};
</script>
